const notInTreatmentStates = ["discharged", "in_selfcare", "treatment_ended", "explore"];

export const patientNotInTreatment = (state?: string) => {
  if (!state) return;
  if (notInTreatmentStates.includes(state)) return true;

  return false;
};
